import React, { Component } from "react";
import { connect } from "react-redux";
import { signIn } from "../../store/actions/authActions";
import { Redirect } from "react-router-dom";
import "./SignIn.css";
import { Button, Form } from "semantic-ui-react";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";

class SignIn extends Component {
  state = {
    email: "",
    password: "",
  };

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.signIn(this.state);
  };

  render() {
    const { authError, auth, superAdmin } = this.props;

    if (auth.uid) {
      if (superAdmin !== null) {
        if (superAdmin) {
          return <Redirect to={`/super-admin`} />;
        } else {
          return <Redirect to={`/admin/` + auth.uid} />;
        }
      } else {
        return (
          <>
            <div className="LoadingContainer">
              <h3>Loading</h3>
            </div>
          </>
        );
      }
    } else {
      return (
        <div className="SignInBackground">
          <div className="SignInBannerBar"></div>
          <div className="SignInContainer">
            <div className="SignIn">
              <Form onSubmit={this.handleSubmit}>
                <div className="LoginHeader">
                  <h2>Sign In to CSA</h2>

                  <div className="anchor-div">
                    New Here?{" "}
                    <a href="/signup">
                      <span className="link-signup">Join CSA</span>
                    </a>
                  </div>
                </div>
                <div className="form-group cu-form-groups">
                  <label>Email</label>
                  <input
                    type="email"
                    placeholder="Email"
                    id="email"
                    value={this.state.email}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="form-group cu-form-groups">
                  <label>Password</label>
                  <input
                    type="password"
                    placeholder="Password"
                    id="password"
                    value={this.state.password}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="ButtonMessageContainer">
                  <Button type="submit">Login</Button>
                  {authError ? <p>{authError}</p> : null}
                </div>
                <div className="SignInForgotPasswordContainer">
                  <a href="/forgot-password">Forgot Password?</a>
                </div>
              </Form>
            </div>
          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    authError: state.auth.authError,
    auth: state.firebase.auth,
    superAdmin: state.auth.superAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signIn: (creds) => dispatch(signIn(creds)),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect([
    {
      collection: "userRole",
    },
    {
      collection: "testNewRequests",
    },
  ])
)(SignIn);
